import { observer } from 'mobx-react-lite'
import React from 'react'
import CustomRating from '../../../../FormComponents/CustomRating'

export default observer(function RatingBox({ text, rating, number_of_reviews, highlighted }) {

  return (
    <div className={`flex-1 flex flex-col items-center p-5 rounded-xl ${highlighted ? 'bg-rb-green/10 dark:bg-rb-green/20' : 'bg-gray-50 dark:bg-rb-dark-mode-lighter'}`}>
      <p className="font-semibold text-sm text-gray-500 dark:text-gray-400">{text}</p>
      <p className="font-bold text-5xl my-2 dark:text-white">{number_of_reviews ? rating.toFixed(1) : '–'}</p>
      <CustomRating initialRating={rating} readonly />
      <p className="text-gray-400 text-xs mt-1">{number_of_reviews} review{number_of_reviews === 1 ? '' : 's'}</p>
    </div>
  )
})
